import { useTranslation } from 'react-i18next';
import { StatsCards } from '../../common/StatsCards/StatsCards';
import type { AdminStatsResponse } from '../../../types';

interface OverviewStatsProps {
  stats: AdminStatsResponse;
}

export function OverviewStats({ stats }: OverviewStatsProps) {
  const { t } = useTranslation();

  const items = [
    {
      title: t('admin.totalUsers'),
      value: stats.users,
      icon: (
        <svg viewBox="0 0 24 24" width="24" height="24" fill="none" stroke="currentColor" strokeWidth="2">
          <path d="M17 21v-2a4 4 0 0 0-4-4H5a4 4 0 0 0-4 4v2"/><circle cx="9" cy="7" r="4"/>
        </svg>
      ),
      iconColorClass: 'stat-color-brand',
    },
    {
      title: t('admin.totalBookings'),
      value: stats.bookings,
      icon: (
        <svg viewBox="0 0 24 24" width="24" height="24" fill="none" stroke="currentColor" strokeWidth="2">
          <path d="M8 2v4" /><path d="M16 2v4" /><rect x="3" y="4" width="18" height="18" rx="2" /><path d="M3 10h18" />
        </svg>
      ),
      iconColorClass: 'stat-color-teal',
    },
    {
      title: t('admin.totalMessages'),
      value: stats.messages,
      icon: (
        <svg viewBox="0 0 24 24" width="24" height="24" fill="none" stroke="currentColor" strokeWidth="2">
          <path d="M21 15a2 2 0 0 1-2 2H7l-4 4V5a2 2 0 0 1 2-2h14a2 2 0 0 1 2 2z"/>
        </svg>
      ),
      iconColorClass: 'stat-color-brand',
    },
  ];

  return <StatsCards items={items} />;
}
